import Tag from './tag';

const TagList = ({ tags = [], hrefMode, categories = [] }) => {
    const items = tags.length
        ? tags
        : categories.map(({ key, name, value, adaptedValue }) => ({
              text: value || name,
              key: key || name,
              adaptedValue
          }));

    return (
        <div className="flex gap-2">
            {items.map(({ text, ...rest }) => (
                <Tag
                    {...rest}
                    text={text}
                    categories={categories}
                    hrefMode={hrefMode}
                    key={rest.key || text}>
                    <span className="px-4 py-1 text-xs font-semibold uppercase">{text}</span>
                </Tag>
            ))}
        </div>
    );
};

export default TagList;
